export const projObjOne = {
    bigid: 'Projects',
    id: 'vandals',
    heading: 'Vandals Sticker Marketplace',
    description: `Developed with Ruby on Rails, this two-sided marketplace has User authentication, stripe payment API and CRUD operations. Heroku was used for deployment, Ultrahook, AWS/S3 image hosting and Figma Wireframes. `,
    webtext: "Open Vandals",
    html:"https://vandals-marketplace.herokuapp.com/" ,
    img: require('../../../images/vandals.png').default,

}
export const projObjTwo = {
    id: 'hackathon',
    heading: 'Hackathons',
    description: `I participated in 48 hour hackathons with fellow classmates in order to challenge ourselves using JavaScript and React. Git collaboration workflows were established in order to effectively work together. Trivia Master is one of our hackathons, where I was responsible for the Front End Development, designing the wireframes in Figma (inspired by Kahoot!) and front-end with React/HTML/CSS/Bootstrap.`,
    webtext: "Open Trivia Master",
    html:"https://natalielouise91.github.io/Hackathon1/" ,
    img: require('../../../images/triviamaster.png').default,
}
export const projObjThree = {
    id: 'waff',
    heading: 'Wes Anderson Film Festival',
    description: `For our final assessment at Coder Academy, My group and I created a Wes Anderson themed Film Festival Web App where users are able to see film schedules, summaries and book tickets. I developed this with 2 other classmates, and designed the wireframes in Figma and built the front end with React.`,
    webtext: "See WAFF website",
    html:"https://wesandersonfilmfestival.netlify.app/" ,
    img: require('../../../images/waff.png').default,
 }
//  export const projObjFour = {
//     id: 'tanda',
//     heading: 'Tanda Internship',
//     description: `During my 6 weeks at Tanda, we went through intensive technical and soft skill training and worked through an entire product pipeline. As interns we technically scoped and shaped a Feature for the product, created an Epic with tasks and successfully shipped a Feature on our own with the support of senior developers.`,
//     webtext: "See WAFF website",
//     html:"https://wesandersonfilmfestival.netlify.app/" ,
//     img: require('../../../images/waff.png').default,
//  }